import React, {useEffect, useRef} from 'react'
import { Box, Button, Skeleton, Typography, Tooltip } from "@mui/material";
import { Toast } from "primereact/toast";
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { useSelector, useDispatch} from 'react-redux';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import IconButton from '@mui/material/IconButton';
import { Menu as PrimeMenu } from 'primereact/menu';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import CustomAxios from '../utils/CustomAxios';
import { blobSrc } from '../utils/blobUrl';
import { useGetCampaign } from '../Components/globalFunctions';
import { ToastContainer, toast } from 'react-toastify';
import { updateEdit, updateCampaignDetails, updateModal } from '../Redux/campaign';


export function Campaign_table() {

    const toast  = useRef(null)
    const campaign = useSelector(state => state.campaign.campaign)
    const campaignLoading  = useSelector(state => state.campaign.loading);
    const search = useSelector(state => state.campaign.searchCampaign)
    const dispatch = useDispatch();
    const menuRefs = useRef([]);
    const getCampaign = useGetCampaign()


    const handleOpen = (row) => {
      const modifiedRow = {
          ...row,
          inventory: row.inventory.map((val) => val.id)
      };
  
      console.log("Mapped Inventory IDs:", modifiedRow.inventory);
  
      dispatch(updateEdit(true));
      dispatch(updateCampaignDetails(modifiedRow));
      dispatch(updateModal(true));
  };

    const confirmDelete = (item) => {
        // The handle is kept so `accept` can close the dialog itself. Left to
        // PrimeReact's own hide, the dialog stayed up behind the "Campaign
        // Deleted Successfully" toast -- the delete, the list refresh and the
        // toast all land after the click handler has returned, and something in
        // that re-render put the dialog back. Closing it by hand does not
        // depend on which.
        const dialog = confirmDialog({
              message: (
                <Box sx={{ display: "flex", gap: "10px",flexDirection:"column" }}>
                  <Box sx={{ display: "flex", gap: "5px",alignItems:"center" }}>
                    {item.campaign_image_urls.map((img) => (<Box component='img' src={blobSrc(img)} sx={{ width: "40px", height: "40px", borderRadius: "8px", marginRight: "10px" }}></Box>))}
                    <Box >{item.description}</Box>
                  </Box>
                  <Typography sx={{fontSize:"16px",fontWeight:500}}>Do you want to delete this Campaign </Typography>
                </Box>
              ),
              header: 'Delete Confirmation',
              defaultFocus: 'reject',
              acceptClassName: 'p-button-danger',
              accept: () => accept(item.id, dialog),
              reject: () => dialog.hide(),
            });
    }

      const accept = async (id, dialog) => {
        // Trailing slash: the route is `campaigns/delete/<pk>/`, and APPEND_SLASH
        // cannot rescue a DELETE the way it rescues a GET.
        try {
          await CustomAxios.delete(`campaigns/delete/${id}/`);
          getCampaign()
          toast.current.show({ severity: 'success', summary: 'Success', detail: 'Campaign Deleted Successfully', life: 3000 });
        } catch (err) {
          console.error(err);
          toast.current.show({
            severity: 'error',
            summary: 'Delete failed',
            detail: err.response?.data?.message || err.response?.data?.error || 'Could not delete this campaign',
            life: 4000,
          });
        } finally {
          // Closed on failure too: a dialog left open over an error toast reads
          // as "nothing happened, try again", and the second try deletes twice.
          dialog?.hide();
        }
      }

  return (
    <Box>
        <Toast ref={toast} />
        <ConfirmDialog />
        <Typography sx={{fontSize: "16px", fontWeight: "700", lineHeight: "24px"}}>Campaign List</Typography>
        <TableContainer sx={{ height: "100%" }}>
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                <TableHead style={{ backgroundColor: "background.upload" }}>
                    <TableRow >
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S No</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Campaign Images</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Hubs</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Description</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Launch Date</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">End Date</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Status</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
  {campaign?.length > 0
    ? campaign ?.filter((item) => {
          if (!item.description) return false; // Exclude items without a description
          return search !== ""
            ? item.description.toLowerCase().includes(search.toLowerCase()) // Case-insensitive search match
            : true; 
        })
        .map((item, ind) => {
          if (!menuRefs.current[ind]) {
            menuRefs.current[ind] = React.createRef();
          }
          return (
            <>
              {
                <TableRow key={1}>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                    }}
                  >
                    {ind + 1}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                    }}
                  >
                    {item?.images?.map((img) => (
                      <Box
                        component="img"
                        src={blobSrc(img)}
                        sx={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "8px",
                          marginRight: "10px",
                        }}
                      ></Box>
                    ))}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                    }}
                  >
                    {item.inventory?.map(inv => inv.place).join(', ')}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                    }}
                  >
                    {item.description}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                    }}
                  >
                    {item.launch_date}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                    }}
                  >
                    {item.end_date}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                    }}
                  >
                    {item.status}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <PrimeMenu
                      model={[
                        {
                          label: "Edit",
                          command: () => handleOpen(item),
                        },
                        {
                          label: "Delete",
                          command: () => confirmDelete(item),
                        },
                      ]}
                      popup
                      ref={menuRefs.current[ind]} // Use the indexed ref
                      style={{ marginLeft: "", marginTop: "-10px" }}
                      className="custom-menu"
                    />
                    <Tooltip title="View inventory batches" arrow>
                      <IconButton
                        sx={{ textTransform: "none" }}
                        onClick={(event) =>
                          menuRefs.current[ind]?.current?.toggle(event)
                        } // Use the indexed ref to toggle menu
                      >
                        <MoreHorizSharpIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              }
            </>
          );
        })
    : (
      <TableRow>
        {campaign.length ? (
          <TableCell
            sx={{
              textAlign: "center",
              textTransform: "capitalize",
              backgroundColor: "white",
              height: "200px",
              fontWeight: "700",
            }}
            colSpan={12}
          >
            <Box>
              <Box sx={{ width: "80%" }}>
                <Skeleton
                  animation="wave"
                  sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }}
                />
                <Skeleton
                  animation="wave"
                  sx={{ background: "rgb(0 0 0 / 6%)" }}
                />
              </Box>
              <Box sx={{ width: "80%" }}>
                <Skeleton
                  animation="wave"
                  sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }}
                />
                <Skeleton
                  animation="wave"
                  sx={{ background: "rgb(0 0 0 / 6%)" }}
                />
              </Box>
              <Box sx={{ width: "80%" }}>
                <Skeleton
                  animation="wave"
                  sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }}
                />
                <Skeleton
                  animation="wave"
                  sx={{ background: "rgb(0 0 0 / 6%)" }}
                />
              </Box>
            </Box>
          </TableCell>
        ) : (
          <TableCell
            sx={{
              textAlign: "center",
              textTransform: "capitalize",
              backgroundColor: "white",
              height: "200px",
              fontWeight: "700",
            }}
            colSpan={7}
          >
            No Campaign Details Available
          </TableCell>
        )}
      </TableRow>
    )}
</TableBody>

            </Table>
        </TableContainer>
    </Box>
  )
}

